<div class="lcl-shipment-voyage-info">
  <div class="tracking-state-container">
    <div
      class="tracking-state-container__label"
      [ngClass]="{
        'tracking-state-container__label-unfilled': shipment?.trackingState !== 0 && shipment.state !== enumShipmentState.CANCELED,
        'tracking-state-container__label-canceled': shipment.state === enumShipmentState.CANCELED
      }"
    >
      <i class="fa fa-check" *ngIf="shipment?.trackingState !== 0 && shipment.state !== enumShipmentState.CANCELED"></i>
      {{
        (shipment.state !== enumShipmentState.CANCELED
          ? "LCL_TRACKING_STATE." + lclTrackingStates[shipment?.trackingState]
          : "STATUS_MANUAL.CANCELED"
        ) | translate
      }}
    </div>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>{{ "LCL_SHIPMENT.DASHBOARD.VOYAGE_NUM" | translate }}</p>
    <span>{{ shipment?.voyage?.voyageNumber }}</span>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>{{ "LABELS.VESSEL_NAME" | translate }}</p>
    <span>{{ shipment?.voyage?.vesselName }}</span>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>
      {{ (!!shipment?.voyage?.actualDepartureTime ? "LABELS.ATD" : "LABELS.ETD") | translate }}
    </p>
    <span>
      {{
        (!!shipment?.voyage?.actualDepartureTime ? shipment?.voyage?.actualDepartureTime : shipment?.voyage?.estimatedDepartureTime)
          | customDateByUtc
      }}
    </span>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>
      {{ (!!shipment?.voyage?.actualArrivalTime ? "LABELS.ATA" : "LABELS.ETA") | translate }}
    </p>
    <span>
      {{
        (!!shipment?.voyage?.actualArrivalTime ? shipment?.voyage?.actualArrivalTime : shipment?.voyage?.estimatedArrivalTime)
          | customDateByUtc
      }}
    </span>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>{{ "LABELS.PREPARATION_CUTOFF" | translate }}</p>
    <span>{{ shipment?.voyage?.warehouseCutoff | customDateByUtc }}</span>
  </div>
  <div class="lcl-shipment-voyage-info__cell">
    <p>{{ "LABELS.CREATION_DATE" | translate }}</p>
    <span>{{ shipment?.modificationData?.createdDate | customDateByUtc }}</span>
  </div>
</div>
